import { useEffect } from 'react';
import { useTenant } from './useTenant';

export function useDynamicFavicon() {
  const { tenantInfo, isCustomDomain, tenantName } = useTenant();

  useEffect(() => {
    // Only set dynamic favicon for custom domains
    if (!isCustomDomain || !tenantInfo?.logoImageUrl) {
      return;
    }

    // Create a new favicon link element
    const favicon = document.createElement('link');
    favicon.rel = 'icon';
    favicon.type = 'image/x-icon';
    favicon.href = tenantInfo.logoImageUrl;

    // Remove existing favicon links
    const existingFavicons = document.querySelectorAll('link[rel="icon"], link[rel="shortcut icon"]');
    existingFavicons.forEach(link => link.remove());

    // Add the new favicon
    document.head.appendChild(favicon);

    // Also update the document title if we have tenant name
    if (tenantName && tenantName !== 'Charity Auctions') {
      document.title = tenantName;
    }

    // Cleanup function to restore default favicon when component unmounts
    return () => {
      if (isCustomDomain) {
        // Only restore if we're still on a custom domain
        const currentFavicons = document.querySelectorAll('link[rel="icon"], link[rel="shortcut icon"]');
        currentFavicons.forEach(link => link.remove());
        
        // Restore default favicon
        const defaultFavicon = document.createElement('link');
        defaultFavicon.rel = 'icon';
        defaultFavicon.type = 'image/svg+xml';
        defaultFavicon.href = '/favicon.svg';
        document.head.appendChild(defaultFavicon);

        const legacyFavicon = document.createElement('link');
        legacyFavicon.rel = 'icon';
        legacyFavicon.type = 'image/x-icon';
        legacyFavicon.href = '/favicon.ico';
        document.head.appendChild(legacyFavicon);
      }
    };
  }, [tenantInfo, isCustomDomain, tenantName]);

  return {
    isCustomDomain,
    tenantName,
    tenantLogo: tenantInfo?.logoImageUrl,
  };
}
